import React from 'react'
import PropTypes from 'prop-types'

// Styled Elements
import { Wrapper, BarBackdrop, BarLine } from './ProgressBar.elements'

function ProgressBar(props) {
  // Destructure
  const { width, failed } = props

  return (
    <Wrapper>
      <BarBackdrop />
      <BarLine failed={failed} style={{ width }} />
    </Wrapper>
  )
}

// Default Props
ProgressBar.defaultProps = {
  width: '',
}

// Proptypes Validation
ProgressBar.propTypes = {
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  failed: PropTypes.bool,
}

export default ProgressBar
